
import { Box, Grid, Table, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import { useTransform, motion, useScroll } from 'motion/react';
import { useContext, useRef } from 'react';
import { ScrollContext } from '../../features/scroll-context/ScrollContext'
import VeganIcon from '../../assets/veganIcon.webp'
import { NutritionFacts, Pricing, PricingTable } from '../../content/menu-items';

export const AnimatedMenuItemRow = ({ image, title, description, pricing, isVegan, targetScale, index, range}: { image: string, title: string, description: string, pricing?: Pricing, isVegan: boolean, targetScale: number, index: number, range: number[]}) => {

    const container = useRef(null);
    const { scrollYProgress } = useScroll({
        target: container,
        offset: ['start end', 'start start']
    })
    const scrollContext = useContext(ScrollContext);
    const progress = scrollContext?.progress;
    const scale = useTransform(progress? progress : scrollYProgress, range, [  1, targetScale]);
    const imageScale = useTransform(scrollYProgress, [0, 1], [1.7, 1.25])

    return (

        <Box 
            ref={container} 
            sx={{
                position: 'sticky', top: { xs: '10vh', md: '200px'}, 
                height:{ xs: '80vh', md: '60vh'}, 
                display: 'flex', 
                flexDirection: 'column',
                alignItems: 'center', 
                justifyContent: 'center',
                overflow: 'visible',
                pointerEvents: 'none'
            }}
        >
            <motion.div style={{ scale: scale }} >
                <Grid
                    // onClick={
                    //     ()=>{
                    //         Demodal.open(NutritionModal, { menuItem: {title, description, isVegan, image, nutritionFacts }})
                    //     }
                    // } 
                    //onMouseOut={()=>{setIsSelected(false)}} 
                    container 
                    spacing={0} 
                    maxWidth='1000px' width={{ xs: "75vw", md: "90vw" }} m='auto' height={{ xs: "520px", md: '300px', lg: '300px'}}
                    style={{
                        overflowY: 'visible',
                        pointerEvents: 'all',
                        backgroundColor: index % 2 === 0 ? '#1a1a1a' : '#3a3a3a', 
                        borderRadius: '12px', 
                        border: '1px solid rgb(189, 0, 0)', 
                        filter:'drop-shadow(0px 0px 12px black)',
                        position: 'relative',
                        top:  `calc(-5vh + ${index * 50}px)`,
                        transformOrigin: 'top',
                    // transform: `scale (${isSelected? scale.get()* 1.25: scale.get()})`
                    }}
                >
                    <Grid 
                        item 
                        xs={12} md={6} p={2} 
                        display={index % 2 === 0 ? {xs:'flex', md:'flex'} : {xs:'flex', md:'none'}} 
                        justifyContent='center' alignItems='top'
                    >
                        <Box
                            sx={{
                                overflow: 'visible',
                                borderRadius: '12px',
                                maxHeight: { xs: '240px', md: '300px'},
                            }}
                        >
                            <motion.img 
                                src={image} 
                                style={{ 
                                    width: '100%', 
                                    height: '100%',
                                    filter: `drop-shadow(0px 16px 8px black)`, 
                                    borderRadius: '12px',
                                    scale: imageScale,
                                    transformOrigin: 'center center',
                                    objectFit: 'contain'
                                }}
                            />
                        </Box>
                    </Grid>
                    
                    {/* Text Section */}
                    <Grid item xs={12} md={6} p={1} sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                        <Grid container margin={0} p={0}>
                            {isVegan && 
                            <Grid item xs={1} sx={{ml:'0px', pl:"0px"}}>
                                <motion.img 
                                    src={VeganIcon} 
                                    style={{ 
                                        width: '42px', 
                                        height: '42px',
                                        position: 'relative',
                                        justifyContent: 'flex-start',
                                        alignItems: 'flex-start',
                                        filter: 'drop-shadow(0px 8px 8px black)', 
                                        marginTop: '-5px',
                                        transformOrigin: 'center center',
                                        objectFit: 'contain'
                                    }}
                                />
                            </Grid>
                            }
                            <Grid item xs={isVegan?11:12}>
                                <Typography mb={1} sx={{ color: 'white', fontWeight: 'bold', fontSize: {xs: '20px', md: '24px'} }}> 
                                    {title}
                                </Typography>
                            </Grid>
                        </Grid>
                        <Grid container alignContent='center' alignItems='center' justifyContent='center'>
                            <Typography sx={{ width:'90%', color: 'white', textAlign: 'left', fontSize: { xs: '18px', md: '20px' }, zIndex: 1000 }} mb={2} height="auto">
                                {description}
                            </Typography>
                        </Grid>
                        {/* Pricing Table */}
                            
                        {/* {pricing &&
                            <Grid container xs={12}  
                                sx={{ color: "white" }}
                                
                                justifyContent='space-evenly'
                                width='100%'
                            >
                                <Grid item>
                                    <Grid item sx={{fontWeight: 'bold', mr: '5px'}}>
                                        Taco 
                                    </Grid>
                                    <Grid item>
                                        ${pricing.Taco}
                                    </Grid>
                                </Grid>

                                <Grid item>
                                    <Grid item sx={{fontWeight: 'bold', mr: '5px'}}>
                                        Burrito 
                                    </Grid>
                                    <Grid item>
                                        ${pricing.Burrito}
                                    </Grid>
                                </Grid>
                        
                                <Grid item>
                                    <Grid item sx={{fontWeight: 'bold', mr: '5px'}}>
                                        Plate 
                                    </Grid>
                                    <Grid item>
                                        ${pricing.Plate}
                                    </Grid>
                                </Grid>
                            
                                <Grid item>
                                    <Grid item sx={{fontWeight: 'bold', mr: '5px'}}>
                                        Half Plate 
                                    </Grid>
                                    <Grid item>
                                        ${pricing.HalfPlate}
                                    </Grid>
                                </Grid>

                                <Grid item>
                                    <Grid item sx={{fontWeight: 'bold', mr: '5px'}}>
                                        A La Carte 
                                    </Grid>
                                    <Grid item>
                                        ${pricing.ALaCarte}
                                    </Grid>
                                </Grid>
                            </Grid>
                        } */}
                    </Grid>

             
                    <Grid 
                        item 
                        xs={12} md={6} p={2} 
                        display={index % 2 === 1 ? {xs:'none', md:'flex'} : {xs:'none', md:'none'}} 
                        justifyContent='center' alignItems='top'
                    >
                        <motion.div
                            style={{
                                overflow: 'visible',
                                borderRadius: '12px',
                                maxHeight: '300px'
                            }}
                        >
                            <motion.img 
                                src={image} 
                                style={{ 
                                    width: '100%', 
                                    height: '100%',
                                    filter: `drop-shadow(0px 16px 8px black)`, 
                                    borderRadius: '12px',
                                    scale: imageScale,
                                    transformOrigin: 'center center',
                                    objectFit: 'contain'
                                }}
                            />
                        </motion.div>
                    </Grid>
                </Grid>
            </motion.div>
        </Box>
    )
}